import styled from 'styled-components'

import { colors } from 'app/theme/colors'

export const Body = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`

export const ColumnFlexCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 20px;
`

export const Amount = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: AvenirDemi;
`

export const Inactive = styled.div`
  color: ${colors.grayDark};
`

/* -- open (unsettled) mandate bookings ------------------------------------ */

/* The card is only 232px wide inside its padding, so a row cannot put state,
   amount and subject on one line without truncating the part that matters.
   Each row is therefore two lines — money + state, then what it was for —
   with a colour rail down the left so the list is scannable at a glance. */

const IN_PROGRESS = '#1565c0'
const STALLED = '#c62828'

export const OpenDebits = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
  margin-top: 4px;
  border-top: 1px solid ${colors.grayLight};
`

export const OpenDebitsHeading = styled.div`
  font-family: AvenirDemi;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${(props) => (props.$stalled ? STALLED : colors.textSecondary)};
  text-align: center;
`

export const OpenDebitRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0 4px 8px;
  border-left: 3px solid ${(props) => (props.$stalled ? STALLED : IN_PROGRESS)};
`

export const OpenDebitTop = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 6px;
`

export const OpenDebitAmount = styled.span`
  font-family: AvenirDemi;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  color: ${colors.textPrimary};
`

/* A stalled row is the one that costs money — it reads as "nothing is
   happening", which is exactly when an operator books again. Colour it as a
   warning rather than as neutral progress. */
export const OpenDebitState = styled.span`
  font-family: AvenirDemi;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  text-align: right;
  color: ${(props) => (props.$stalled ? STALLED : IN_PROGRESS)};
`

export const OpenDebitMeta = styled.span`
  font-size: 11px;
  line-height: 15px;
  color: ${colors.textTertiary};
  overflow-wrap: anywhere;
`

export const OpenDebitWarning = styled.div`
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  color: ${(props) => (props.$stalled ? STALLED : colors.textSecondary)};
`
